export default [
  // Main Page
  {
    path: 'notification',
    name: 'website.notification',
    component: () => import('@/views/website/notification/index'),
  },
];
